module.exports = new __parcel__URL__("fuerza-natural.5dc4cef9.jpg").toString();